import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WorkflowStep } from 'src/app/models/workflow-step';

interface EditDescriptionData {
  step: WorkflowStep;
}

@Component({
  selector: 'workflow-step-edit-description-dialog',
  templateUrl: './edit-description.component.html',
  styleUrls: ['./edit-description.component.scss']
})
export class EditWorkflowStepDescriptionComponent {

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<EditWorkflowStepDescriptionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditDescriptionData,
  ) {
    this.form = this.fb.group({
      descrizione: [data?.step?.descrizione || '', [Validators.maxLength(5000)]],
    });
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.form.value.descrizione ?? '');
  }

  cancel(): void {
    this.dialogRef.close(undefined);
  }
}

